import styled from 'styled-components';

export const ChartWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 32px;
  margin-top: 32px;
  margin-bottom: 16px;
  border-radius: 8px;
  overflow: hidden;
`;
export const ChartBar = styled.div<StyleProps>`
  background: ${props => props.background};
  height: 32px;
  width: 100%;
`;
export const KeyWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
`;
export const KeyItem = styled.div`
  display: flex;
  flex-direction: row;
  margin-right: 16px;
  align-items: center;
`;
export const KeySquare = styled.div<StyleProps>`
  width: 8px;
  height: 8px;
  background: ${props => props.background};
  margin-right: 8px;
`;
